<template>
    <b-overlay :show="loading" :opacity="0.4">
        <form class="login-form" @submit.prevent="processLogin" method="post">
            <span class="login-form__login-now">{{ TEXTS.render(`LOGIN_FORM_REGISTER_TEXT`) }}<router-link class="pl-2 d-block" to="/register">{{ TEXTS.render(`LOGIN_FORM_REGISTER_LINK`) }}</router-link></span>
            <h2 class="login-form__title" id="form-entry">{{ TEXTS.render(`LOGIN_FORM_HEADER`) }}</h2>
            <p class="mb-4" v-html="loginText"></p>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group mb-4">
                        <div v-if="emailNotVerified == true" class="text-danger font-sm font-weight-bold mb-2" role="alert">
                            Email address is not verified, please check your email or <button @click="resendConfirmationEmail(tokenHash)" :disabled="!!saving" class="btn-link">click here to send another verification link</button>
                        </div>
                        <div class="text-danger font-weight-bold mb-2" id="errorMessage" role="alert">
                            {{ TEXTS.renderNonAsset(errorMessage) }}
                        </div>
                        <label class="font-weight-bold mb-1" for="details-email">{{ TEXTS.render(`LOGIN_FORM_EMAIL_HEADER`) }}</label>
                        <input id="details-email" type="text" class="form-control" :placeholder="TEXTS.render(`LOGIN_FORM_EMAIL_PLACEHOLDER`)" v-model="details.email">
                        <div class="login-form__validation mt-1 text-danger font-weight-bold" role="alert" v-html="validations.email" />
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group mb-4">
                        <label class="font-weight-bold mb-1" for="details-password">{{ TEXTS.render(`LOGIN_FORM_PASSWORD_HEADER`) }}</label>
                        <input id="details-password" type="password" class="form-control" :placeholder="TEXTS.render(`LOGIN_FORM_PASSWORD_PLACEHOLDER`)" v-model="details.password">
                        <div class="login-form__validation mt-1 text-danger font-weight-bold" role="alert" v-html="validations.password" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <router-link to="/forgotpassword" class="d-inline-block mb-3">{{ TEXTS.render(`LOGIN_FORM_FORGOTTEN_PASSWORD`) }}</router-link>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 d-flex justify-content-left">
                    <div class="recaptcha-wrapper" v-if="csoEnabled === 'false' && recaptchaDisabled === 'false'">
                        <recaptcha @onChange="recaptchaOnChange" v-if="csoEnabled === 'false' && recaptchaDisabled === 'false'"></recaptcha>
                        <div class="login-form__validation mt-1 text-danger font-weight-bold" role="alert" v-html="validations.recaptcha" />
                    </div>
                </div>
            </div>
            <ColoredButton>{{ TEXTS.render(`LOGIN_FORM_BTN_LOGIN`) }}</ColoredButton>
        </form>
    </b-overlay>
</template> 

<script>
    import Texts from '../../../../common/utils/Texts'
    import Recaptcha from '../../../../common/components/Recaptcha';
    import ColoredButton from '../../../../common/components/ColoredButton'
    import helper from '../../../../helper'
    import BookingStateManager from '../../../../common/utils/BookingStateManager'
    import RecaptchaDetectDebugMixin from '../../../../common/mixins/RecaptchaDetectDebugMixin'
    export default {
        mixins: [RecaptchaDetectDebugMixin],
        components: {
            Recaptcha,
            ColoredButton
        },
        data() {
            return {
                recaptchaDisabled: localStorage.recaptchaDisabled,
                csoEnabled: localStorage.csoEnabled,
                recaptchaAccepted: false,
                details: {
                    email: '',
                    password: ''
                },
                validations: {
                    email: '',
                    password: '',
                    recaptcha: '',
                    valid: true
                },
                emailNotVerified: false,
                tokenHash:'',
                errorMessage:'',
                saving: false
            }
        },
        mounted() {
            /**
            * Task:         BAUM-724
            * Author:       Joseph Ricohermoso
            * Date:         2021-07-08
            * Description:  Remove old booking states (past 1 day) in local storage on login form view.
            *               This is just a support fix not the major functionality of this task.
            */
            (new BookingStateManager()).cleanup();
        },
        methods: {
            processLogin(event) {
                setTimeout(() => {
                    this.validateAll();

                    if ((this.csoEnabled === 'false' && this.recaptchaDisabled === 'false') && typeof this.recaptchaAccepted !== 'string') {
                        this.validations.valid = false;
                        this.validations.recaptcha = 'Please confirm that you are a human';
                    }

                    if (this.validations.valid) {
                        // Do API request
                        this.$store.dispatch('loginProcess', { email: this.details.email, password: this.details.password });
                    }
                    if(!this.validations.valid){
                        var errorMessage = document.getElementById("errorMessage")
                        errorMessage ? helper.scrollIntoView(errorMessage) : nulls
                    }
                }, 200)
            },
            recaptchaOnChange(e) {
                if (typeof e === 'string') {
                    this.recaptchaAccepted = e;
                }
                if (e === undefined) {
                    this.recaptchaAccepted = false;
                    this.validations.valid = false;
                    this.validations.recaptcha = 'Please confirm that you are a human';
                }
            },
            validateAll(event) {
                this.validations.valid = true;
                this.validations.recaptcha = '';
                this.emailValidate();
                this.passwordValidate();

                if (this.$store.getters['GET_AUTH'].error && this.details.email.trim() === '') {
                    this.$store.dispatch('clearAuthError');
                }
            },
            emailValidate() {
                this.validations.email = '';
                if (!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.details.email)) || !(/^\w+([.-]\w+)*@\w+([.-]\w+)*(\.\w{2,10})+$/.test(this.details.email))) {
                    this.validations.valid = false;
                    this.validations.email = 'Please enter a valid email address';
                }
            },
            passwordValidate() {
                this.validations.password = '';
                if (!this.details.password) {
                    this.validations.valid = false;
                    this.validations.password = 'Please enter a password';
                }
            },
            resendConfirmationEmail(hashCode) {
                this.saving = true;
                this.$store.dispatch('resendConfirmationEmail', hashCode);
                this.emailNotVerified = false;
                Toastify({
                    text: Texts.render(`LOGIN_FORM_VERFICATION_RESENT_SUCCESS`),
                    duration: 5000,
                    gravity: "bottom",
                    position: 'right', 
                    style: {
                        background: '#00B029'
                    },
                    offset: {
                        x: '2rem',
                        y: '2rem'
                    },
                    onClick: function(){} // Callback after click
                }).showToast();
            }
        },
        computed: {
            TEXTS: () => Texts,
            loading() {
                return this.$store.getters['GET_PAGE_LOADING'];
            },
            error() {
                if(this.$store.getters['GET_AUTH'].error == 'Email address is not verified'){
                    var tokenHash = this.$store.getters['GET_AUTH'].token_hash
                    this.emailNotVerified = true;
                    this.tokenHash = tokenHash;
                } else if(this.$store.getters['GET_AUTH'].error === 'Email address is not verified'){
                    var tokenHash = this.$store.getters['GET_AUTH'].token_hash
                    this.emailNotVerified = false;
                    this.tokenHash = tokenHash;
                } else if(this.$store.getters['GET_AUTH'].error){
                    return this.$store.getters['GET_AUTH'].error;
                }
            },
            resendEmailURL(){
                return this.$store.getters.GET_RESEND_CONFIRMATION_EMAIL.message
            },
            loginText() {
                return this.$store.getters['GET_SITE_WORDINGS'] ?
                    (this.$store.getters['GET_SITE_WORDINGS'].login_text || this.TEXTS.render(`LOGIN_FORM_SUBHEADER`))
                    : this.TEXTS.render(`LOGIN_FORM_SUBHEADER`)
            }
        },
        watch: {
            'error': function(message) {
                this.$nextTick(function() {
                    message = helper.reformatErrorMessage(message, 404, 'There was an error encountered while processing your request. Please try again. (Status code: 500)')
                    this.errorMessage = message
                    helper.scrollToTop('form-entry');
                });
            },
            'resendEmailURL': function(message) {
                this.$nextTick(function() {
                    message = helper.reformatErrorMessage(message, 404, 'There was an error encountered while processing your request. Please try again. (Status code: 500)')
                    this.errorMessage = message
                    helper.scrollToTop('form-entry');
                });
            },
            'details.email': function(email){
                if(email.indexOf(' ') > -1){
                    this.details.email = email.replace(/\s/g, '');
                }
            },
        }
    }
</script>